import { z } from 'zod';
/**
 * Blocos reutilizados por todos os contratos.
 *
 * Regras permanentes refletidas aqui:
 * - dinheiro trafega e é persistido em CENTAVOS (inteiro), nunca float;
 * - datas trafegam em ISO-8601 (UTC); a apresentação em America/Sao_Paulo é do cliente;
 * - identificadores são cuid/uuid opacos (string).
 */
export const idSchema = z.string().min(1, 'Identificador obrigatório').max(64);
/** Valor monetário em centavos. R$ 1.234,56 => 123456. */
export const centsSchema = z
    .number()
    .int('Use centavos (número inteiro)')
    .describe('Valor em centavos (BRL)');
/** Valor monetário em centavos, positivo (não aceita zero). */
export const positiveCentsSchema = centsSchema.positive('Valor deve ser maior que zero');
export const isoDateTimeSchema = z.iso.datetime({ offset: true }).or(z.iso.datetime());
export const isoDateSchema = z.iso.date();
export const emailSchema = z.email('E-mail inválido').max(180).toLowerCase().trim();
/** Telefone brasileiro: apenas dígitos, 10 (fixo) ou 11 (celular). */
export const phoneSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/\D/g, ''))
    .refine((v) => v === '' || v.length === 10 || v.length === 11, {
    message: 'Telefone deve ter 10 ou 11 dígitos (com DDD)',
});
export const ufSchema = z
    .string()
    .trim()
    .toUpperCase()
    .length(2, 'UF deve ter 2 letras')
    .regex(/^[A-Z]{2}$/, 'UF inválida');
export const cepSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/\D/g, ''))
    .refine((v) => v === '' || v.length === 8, { message: 'CEP deve ter 8 dígitos' });
export const SORT_DIRECTIONS = ['asc', 'desc'];
export const sortDirectionSchema = z.enum(SORT_DIRECTIONS);
/** Query padrão de listagem: paginação por página + busca livre + ordenação. */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(25),
    search: z.string().trim().max(160).optional(),
    sort: z.string().trim().max(60).optional(),
    direction: sortDirectionSchema.default('asc'),
});
export const paginationMetaSchema = z.object({
    page: z.number().int(),
    perPage: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
});
/** Envelope padrão de listagem paginada. */
export function paginated(item) {
    return z.object({ data: z.array(item), meta: paginationMetaSchema });
}
/** Metadados de autoria/soft delete presentes em todo registro do núcleo. */
export const auditFieldsSchema = z.object({
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    createdById: idSchema.nullable(),
    updatedById: idSchema.nullable(),
});
export const okSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=common.js.map